import * as Step from "../../core/script/StepExecutor";

/**
 * Class used to alert UI when test is done
 */
export default class EQmScoreStepDone {

    /**
     *
     * @param {string} status
     * @param {string} direction
     * @param {number} service
     * @param {number} module
     * @param {boolean} computeFailed
     * @param {number} totalBytes
     * @param {number} sessionTime
     * @param {number} maxThroughput
     * @param {number} averageThroughput
     * @param {number} minLatency
     * @param {Object} extras
     * @param {string} baseUrl
     * @param {number} mos
     * @param {string} rootCauseAnalysis1
     * @param {string} chartUrl
     */
    constructor(status, direction, service, module = null, computeFailed = true, totalBytes = 0, sessionTime = 0, maxThroughput = 0, averageThroughput = 0, minLatency = 0, extras = null, baseUrl = '', mos = null, rootCauseAnalysis1 = null, chartUrl = null) {
        this.type = Step.STEP_MSCORE;
        this.computeFailed = computeFailed;
        this.status = status;
        this.direction = direction;
        this.service = service;
        this.module = module;
        this.totalBytes = totalBytes;
        this.sessionTime = sessionTime;
        this.maxThroughput = maxThroughput;
        this.averageThroughput = averageThroughput;
        this.minLatency = minLatency;
        this.extras = extras;
        this.baseUrl = baseUrl;
        this.mos = mos;
        this.rootCauseAnalysis1 = rootCauseAnalysis1;
        this.chartUrl = chartUrl;
    }
}



// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQmScoreStepDone.js